export const deepMerge = (a: Record<string, any>, b: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};
  for (const key of new Set([...Object.keys(a), ...Object.keys(b)])) {
    result[key] =
      a[key]?.constructor === Object && b[key]?.constructor === Object ? deepMerge(a[key], b[key]) : structuredClone(b[key] !== undefined ? b[key] : a[key]);
  }
  return result;
};
